"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var getErrors = function getErrors(errors, name) {
  return errors[name] && errors[name].join(',');
};

var hasError = function hasError(errors, name) {
  return !!errors[name];
}; // Basic text input field


var BaseField = function BaseField(_ref) {
  var name = _ref.name,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? {} : _ref$errors,
      _ref$showError = _ref.showError,
      showError = _ref$showError === void 0 ? true : _ref$showError,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["name", "errors", "showError"]);
  return /*#__PURE__*/_react["default"].createElement(_material.TextField, (0, _extends2["default"])({
    id: "field-".concat(name, "-id"),
    name: name,
    variant: "outlined",
    error: showError && hasError(errors, name),
    helperText: showError && getErrors(errors, name)
  }, otherProps));
};

var _default = BaseField;
exports["default"] = _default;